"use strict";
/* globals module */
/**
 * @module notificationsRegistrationsUsersBatchClient
 * @description  Notifications Registrations Users Batch Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsRegistrationsUsersBatchClient` uses `notificationsRegistrationsUsersBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var httpApi_1 = require("../../httpApi");
;
var _1 = require("./");
var NotificationsRegistrationsUsersBatchClient = /** @class */ (function () {
    function NotificationsRegistrationsUsersBatchClient(notificationsRegistrationsUsersBatchRoute, apiClient) {
        this.notificationsRegistrationsUsersBatchRoute = notificationsRegistrationsUsersBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsRegistrationsUsersBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRegistrationsUsersBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create user registration action has been performed; this action creates new user registration resources.
     * @method
     * @param data UserRegistration collection that need to be inserted into the system.
     * @returns A promise that is resolved once the create user registration action has been performed.
     * @example notificationsRegistrationsUsersBatchClient.create([{
                    provider: '<provider-name>',
                    providerData: <provider-data>,
                    userId: '<user-id>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsRegistrationsUsersBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove user registration resources from the system if successfully completed.
     * @method
     * @param ids The subscription ids which uniquely identify UserRegistration resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example notificationsRegistrationsUsersBatchClient.remove(subscriptionIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsRegistrationsUsersBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.notificationsRegistrationsUsersBatchRoute.delete(), undefined, ids);
    };
    /**
     * Returns a promise that is resolved once the update user registration action has been performed; this action updates specified user registration resources.
     * @method
     * @param data UserRegistration objects used to update specified UserRegistration resources.
     * @returns A promise that is resolved once the update user registration action has been performed.
     * @example notificationsRegistrationsUsersBatchClient.update(registrations)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsRegistrationsUsersBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    NotificationsRegistrationsUsersBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsRegistrationsUsersBatchRoute !== "undefined" && _1.NotificationsRegistrationsUsersBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsRegistrationsUsersBatchClient);
    return NotificationsRegistrationsUsersBatchClient;
}());
exports.NotificationsRegistrationsUsersBatchClient = NotificationsRegistrationsUsersBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
